import React, { useState, useCallback, useEffect } from 'react';
import styled from '@emotion/styled';
import Checkbox from '../../Form/Checkbox';
import { colors, fontSize } from '../../../global/variables';
import {
  AVOID_TRUCK_ROAD_TYPES,
  buildTruckRoadTypesPayload,
} from '../../../utils/avoidAreaHelpers';

const { secondaryTextColor, primaryTextColor, secondaryBorderColor } = colors;
const { small, smaller } = fontSize;

const StyledSection = styled.details({
  backgroundColor: 'rgba(0,0,0,.025)',
  border: `1px solid ${secondaryBorderColor}`,
  borderRadius: '0.12rem',
  padding: '0.75rem',
  marginBottom: '0.9rem',
});

const StyledSummary = styled.summary({
  fontSize: small,
  fontWeight: 700,
  color: primaryTextColor,
  cursor: 'pointer',
});

const StyledSummaryHint = styled.span({
  fontSize: smaller,
  fontWeight: 400,
  color: secondaryTextColor,
  marginLeft: '0.3rem',
});

const StyledCheckRow = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.3rem',
  marginTop: '0.75rem',
});

const TruckRoadTypesEditor = ({
  truckRoadTypes,
  onChange,
  labels: { truckRoadTypesTitle, truckRoadTypesHint, avoidTruckRoadTypesLabels },
}) => {
  const [selected, setSelected] = useState(truckRoadTypes || []);

  useEffect(() => {
    onChange(buildTruckRoadTypesPayload({ truckRoadTypes: selected }));
  }, [selected, onChange]);

  const onToggle = useCallback((roadType) => {
    setSelected((prev) =>
      prev.includes(roadType) ? prev.filter((r) => r !== roadType) : [...prev, roadType],
    );
  }, []);

  return (
    <StyledSection>
      <StyledSummary>
        {truckRoadTypesTitle}
        <StyledSummaryHint>{truckRoadTypesHint}</StyledSummaryHint>
      </StyledSummary>
      <StyledCheckRow>
        {AVOID_TRUCK_ROAD_TYPES.map((roadType) => (
          <Checkbox
            key={roadType}
            id={`checkbox-fleet-profile-truck-road-type-${roadType}`}
            value={selected.includes(roadType)}
            label={avoidTruckRoadTypesLabels[roadType]}
            onChange={() => onToggle(roadType)}
          />
        ))}
      </StyledCheckRow>
    </StyledSection>
  );
};

export default TruckRoadTypesEditor;
